
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50 100a50 50 0 1150-50 50 50 0 01-50 50zm25.76-66.41l-9.35-9.34L50 40.65l-16.41-16.4-9.35 9.34L40.65 50 24.24 66.4l9.35 9.35L50 59.35l16.41 16.41 9.35-9.35L59.35 50z"}})])
          )
        }
      }
    